import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
}
const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  className = '',
  ...props
}) => {
  const baseClasses = 'rounded-full font-medium transition-all duration-200 flex items-center justify-center';
  const variantClasses = {
    primary: 'bg-[#00E4BB] text-[#1A237E] hover:bg-[#00E4BB]/90 shadow-lg shadow-[#00E4BB]/20',
    secondary: 'bg-[#8E24AA] text-[#FAFAFA] hover:bg-[#8E24AA]/90 shadow-lg shadow-[#8E24AA]/20',
    outline: 'bg-transparent border-2 border-[#00E4BB] text-[#00E4BB] hover:bg-[#00E4BB]/10'
  };
  const sizeClasses = {
    sm: 'text-sm py-1.5 px-4',
    md: 'text-base py-2.5 px-6',
    lg: 'text-lg py-3 px-8'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`} {...props} data-id="element-1510">
      {children}
    </button>;
};
export default Button;